import Cookies from "js-cookie";

export const getTrackingParams = (): {
  pagePath: string;
  pageTitle: string;
  realEstateId: string | undefined;
} => {
  const pagePath = document.location.pathname.replace(/^\//, "");
  const params = new URLSearchParams(document.location.search);
  const realEstateId =
    pagePath === "valuation_report"
      ? params.get("realEstateId") || Cookies.get("realEstateId") || undefined
      : undefined;

  return {
    pagePath,
    pageTitle: `sn.de.${pagePath}`,
    realEstateId,
  };
};
